import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useNavigate } from "react-router-dom";
import { BoxContainer } from '../layouts/Theme';
import { useI18N } from '../context/I18NContext';
export default function Cancelled(props) {
    const { t } = useI18N();
    const navigate = useNavigate();
    const goTo = (e) => {
        let target = e.target.closest('button');
        let path = target.getAttribute('rel');
        navigate(`/${path}`);
    };
    return (_jsxs(BoxContainer, { children: [_jsx(Typography, { variant: "h6", children: t('Je afspraak is geannuleerd') }), _jsx(Button, { onClick: goTo, rel: 'oa_widget_appointments', fullWidth: true, variant: "contained", children: t('Terug naar afspraken') })] }));
}
